import { ButtonLink } from '@/components/ui/Button'
import { useTranslator } from '@/hooks/useTranslator'
import { useSelector } from '@/stores/hooks'
import { getPoi } from '@/stores/pois'
import type { PopupInfo } from '@/stores/temp'
import { classes } from '@lc/libreact'
import styles from '@/components/map/render/Popup/PopupButtons/PopupButtonGoThere.scss'

export function PopupButtonGoThere({ id, pos }: PopupInfo) {
  const translator = useTranslator()
  const poi = useSelector(state => getPoi(state, id))

  if (!poi) return null

  let url: string
  {
    const [lat, lon] = pos
    const toName = poi.name

    const searchParams = new URLSearchParams()
    searchParams.set('coord', `${lat};${lon}`)
    searchParams.set('name', toName)

    url = `/around?${searchParams.toString()}`
  }

  return (
    <ButtonLink
      small
      border
      href={url}
      label={translator.translate('poi:see-through-lines')}
      iconUrl="assets/MoreInfo.svg"
      className={classes(styles.button)}
    />
  )
}

__OVERRIDE(PopupButtonGoThere)
